import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltVideoEditorPlayerZoomButtonOptionsListWireframe from './VeltVideoEditorPlayerZoomButtonOptionsListWireframe/VeltVideoEditorPlayerZoomButtonOptionsListWireframe';
import VeltVideoEditorPlayerZoomButtonOptionsInputWireframe from './VeltVideoEditorPlayerZoomButtonOptionsInputWireframe/VeltVideoEditorPlayerZoomButtonOptionsInputWireframe';
var VeltVideoEditorPlayerZoomButtonOptionsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-zoom-button-options-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerZoomButtonOptionsWireframe.List = VeltVideoEditorPlayerZoomButtonOptionsListWireframe;
VeltVideoEditorPlayerZoomButtonOptionsWireframe.Input = VeltVideoEditorPlayerZoomButtonOptionsInputWireframe;
export default VeltVideoEditorPlayerZoomButtonOptionsWireframe;
